import {withPayloadType} from '@lib/utils';
import {createAction} from '@reduxjs/toolkit';

export const setWorkspaceLocation = createAction(
  'onboarding/setWorkspaceLocation',
  withPayloadType<{floorId: string | null; areaId: string | null; deskAmenities: string[]}>(),
);

export const setParkingLocation = createAction(
  'onboarding/setParkingLocation',
  withPayloadType<{parkingLotId: string | null; parkingZoneId?: string | null}>(),
);

export const setIsDeskRequired = createAction('onboarding/setIsDeskRequired', withPayloadType<boolean>());

export const resetOnboardingState = createAction('onboarding/resetOnboardingState');
